import { IconProps } from 'src/utils/icon';

function MessageIcon({ size = 1, fill = '#2c2a29' }: IconProps) {
  return (
    <svg
      style={{ fontSize: `${size}rem` }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0347 0.5H2.63472C1.36972 0.5 0.346217 1.535 0.346217 2.8L0.334717 23.5L4.93472 18.9H21.0347C22.2997 18.9 23.3347 17.865 23.3347 16.6V2.8C23.3347 1.535 22.2997 0.5 21.0347 0.5ZM8.38472 10.85H6.08472V8.55H8.38472V10.85ZM12.9847 10.85H10.6847V8.55H12.9847V10.85ZM17.5847 10.85H15.2847V8.55H17.5847V10.85Z"
        fill="#007B83"
      />
    </svg>
  );
}

export default MessageIcon;
